///////////////////////////////////
// Инициализация основной страницы.
ongPageInitFuncs.pgBlock_home_init = function()
{
	

}